const splitPathAndQuery = (rawPath) => {
  const trimmed = String(rawPath || "").trim();
  if (!trimmed) {
    return { pathname: "/", search: "" };
  }

  const withoutHash = trimmed.split("#")[0];
  const [pathnamePart, ...searchParts] = withoutHash.split("?");
  return {
    pathname: pathnamePart || "/",
    search: searchParts.length > 0 ? `?${searchParts.join("?")}` : "",
  };
};

export const normalizeRoutePath = (path) => {
  const { pathname } = splitPathAndQuery(path);
  if (!pathname || pathname === "/") return "/";
  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
};

export const normalizeTabPath = (path) => {
  if (!path || typeof path !== "string") return null;
  const { pathname, search } = splitPathAndQuery(path);
  const normalizedPathname = normalizeRoutePath(pathname);
  if (
    [
      "/inventory/counts/selective/new",
      "/inventory/counts/general/new",
      "/inventory/counts/general/capture",
    ].includes(normalizedPathname) &&
    search
  ) {
    const params = new URLSearchParams(search);
    const countId = params.get("count_id");
    if (countId) {
      return `${normalizedPathname}?count_id=${countId}`;
    }
  }
  return `${normalizedPathname}${search}`;
};

export const getTabPathFromLocation = (location) => {
  if (!location || typeof location !== "object") return "/";
  const pathname = String(location.pathname || "/");
  const search = String(location.search || "");
  return normalizeTabPath(`${pathname}${search}`) || "/";
};

export const stripTabSearch = (path) => normalizeRoutePath(path);
